import * as React from 'react';
import set from 'lodash/set';

export function withProperty<P extends object>(propertyPath: string, value: Date | string | number | boolean | Function ) {

  return (WrappedComponent: React.ComponentClass<P> | React.SFC<P>) => {
    return (props) => {
      const modifiedProps: P = {...props};
        set(modifiedProps, propertyPath, value);
        return <WrappedComponent { ...modifiedProps } />;
    };
  };
}
